<template>
	<div class="number">{{ chartData.data.value }}</div>
	<div class="number-description">{{ chartData.data.number_description }}</div>	
</template>

<script>
export default {
	name: 'NumberCard',
	props: {
		data: {
			type: Object,
			default: {}
		},
		options: {
			type: Object,
			default: {}
		},
		plugins: {
			type: Array,
			default: []
		},
		chartData: Object,
		tooltipDefaultConfig: Object,
		hasData: {
			type: Boolean,
			default: false
		},
		feTheme: {
			type: Object,
			default: {
				charts_no_data_text: 'No data'
			}
		}
	}
}
</script>